// extracted by mini-css-extract-plugin
export default {"dot":"GraphGlucoseEntries_dot__9la8J"};